// extracted by css-extract-rspack-plugin
export default {"modal-layout":"RsyLru","modalLayout":"RsyLru","modal-content":"IoMKjM","modalContent":"IoMKjM","subheading":"QDPyjm"};